import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { CampaignDetailPage } from "./campaign-detail";
import { ComponentsModule } from "../../components/components.module";
import { PipesModule } from "../../pipes/pipes.module";

@NgModule({
  declarations: [CampaignDetailPage],
  imports: [
    IonicPageModule.forChild(CampaignDetailPage),
    ComponentsModule,
    PipesModule,
  ],
})
export class CampaignDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/campaign-detail/campaign-detail.module.ts